export const RISK_TYPES = [
  { id: '1', label: '#1 — Не выход на связь', available: true },
  { id: '2', label: '#2 — Показания не передались', available: true },
  { id: '3', label: '#3 — Плохой сигнал', available: true },
  { id: '4', label: '#4 — Батарея', available: true },
  { id: '5', label: '#5 — Плохой SLA', available: false },
  { id: '6', label: '#6 — Датчик протечки', available: false },
  { id: '7', label: '#7 — Авторизация', available: false },
];

export const RISK_SHORT_LABELS = {
  1: 'Не выход',
  2: 'Показания',
  3: 'Сигнал',
  4: 'Батарея',
};

export const RISK_LEVEL_SHORT_LABELS = {
  ok: 'ok',
  low: 'низк.',
  medium: 'средн.',
  high: 'выс.',
  very_high: 'оч.выс.',
};

export function getAvailableRiskTypes() {
  return RISK_TYPES.filter((risk) => risk.available);
}

export function getDefaultRiskTypesCsv() {
  return getAvailableRiskTypes()
    .map((risk) => risk.id)
    .join(',');
}

export const DEFAULT_RISK_TYPE_ID = '1';

export function getRiskTypeById(id) {
  return RISK_TYPES.find((risk) => risk.id === id) || RISK_TYPES[0];
}

export function getRiskShortLabel(riskNumber) {
  return RISK_SHORT_LABELS[riskNumber] || `#${riskNumber}`;
}

export function getRiskLevelShortLabel(level) {
  return RISK_LEVEL_SHORT_LABELS[level] || level;
}
